import { canv } from '@/canv/global'
import { elementBase } from '@/elementBase/elementBase'
import { widgetOption } from '@/widgetMenu/widgetMenu';
import {
    getStringProperty,
    getNumberProperty,
    getColorProperty,
    getContrastColor,
} from '@/canv/utils';

import { textWidget } from '@/elements/text/text'

export class stickerWidget extends elementBase {

    constructor(startX, startY, color) {
        super();
        this.startX = startX;
        this.startY = startY;
        this.width = 250;
        this.height = 250;
        this.color = color; //"#FFC700";

        // Тут ставим не правильный startY, который поправим в первом же Draw
        this.textPart = new textWidget(this.startX + this.padding, this.startY + this.padding);


        this.textPart.setKeepMinWidth(false);
        this.textPart.stickerMode = true;
        this.textPart.hardWidth = this.width - 2 * this.padding;
        this.textPart.hardHeight = this.height - 2 * this.padding;
        this.textPart.menuTextAlign("center", true);

        this.textPart.updateDims();

        this.updateDims();
    }


    resize(x, y, catchPointer) {

        if (["sideRight", "sideBottom", "sideLeft", "sideTop"].includes(catchPointer)) return;

        var diff = Math.abs(x) > Math.abs(y) ? x : y;

        if (this.height + diff <= 15) return;

        var widthKoef = this.width / this.height;

        this.height += diff;
        this.width += widthKoef * diff;
        this.updateDims();


    }


    makeWide() {
        this.width = 1.8 * this.height;
        this.updateDims();
    }

    makeNormal() {
        this.width = this.height;
        this.updateDims();
    }



    updateDims(onlyPosition = false) {
        if (!onlyPosition) {
            this.padding = 0.1 * this.height;
            this.textPart.hardWidth = this.width - 2 * this.padding;
            this.textPart.hardHeight = this.height - 2 * this.padding;
            this.textPart.fitSticker();
            this.textPart.updateDims();
        }

        this.textPart.startX = this.startX + this.width / 2 - this.textPart.width / 2;
        this.textPart.startY = this.startY + this.height / 2 - this.textPart.height / 2 + this.textPart.lines[0].textHeight;
        this.textPart.updateDims();

        var gap = this.height / 33;
        var bottomGap = this.height / 13;

        this.updateBase(this.startX - gap, this.startY - gap, this.width + 2 * gap, this.height + gap + bottomGap);
    }


    // TryAction, isInteraction ------------------------------------------------------------

    TryAction(type) {
        // TODO: костыль для релиза
        // нужно подмать как исправить асинхронность и тут и в других виджетах
        (async () => {
            await this.textPart.TryAction(type);

            this.updateDims();
        })();

        if (type == "keyboardDown") {
            this.updateDims();
            this.tryShortcut();
        }

        if (type == "mousedown" && !this.textPart.isOver()) {
            if (this.isOver()) {
                canv.toolBox.TryGetToolByName("cursorTool").turnMode("dragging");
            } else {
                canv.toolBox.TryGetToolByName("cursorTool").turnMode("");
                canv.toolBox.TryGetToolByName("cursorTool").TryAction("mousedown");
            }
        }

    }

    isInteraction(context, force = false) {
        if (context === "focus" && this.isOver() || force) {
            this.fixState("textFocus");
            this.textPart.focusText();
            return {
                "type": "interaction",
            }
        }

        if (context === "insertText" || context === 'pastText') {
            this.fixState("textFocus");
            if (canv.keyboard.isEnter()) {
                this.textPart.focusTextByEnter();
            } else if (!canv.keyboard.isEnter()) {
                this.textPart.focusText();
                this.textPart.selection.selectAll();
                this.textPart.processDelete();
                this.TryAction("keyboardDown");
            }
            this.updateDims();
            return {
                "type": "interaction",
            }
        }

        return { "type": "none" };
    }

    stopInteraction() {
        canv.eventManager.openRecord();
        this.saveState("textFocus");
        canv.eventManager.closeRecord();

        this.textPart.unfocusText();
    }

    tryShortcut() {
        if (canv.keyboard.isEscCommand()) {
            // stopInteraction вызывается внутри cursorTool при изменении mode
            canv.toolBox.TryGetToolByName("cursorTool").turnMode("");
        }
    }

    draw() {
        canv.ctx.save();
        const drawShadow = this.width / (canv.canvas.height / canv.m[3]) > 0.01;
        if (drawShadow) {
            canv.ctx.shadowColor = 'rgba(99, 99, 99, 0.2)';
            // 250 - base height
            // 8 - blur size (250/30 ~ 8.3)
            // 0, 2 - offset x, offset y (250/125 = 2)
            canv.ctx.shadowBlur = canv.actionManager.getConstant(this.height / 30) * canv.m[3];
            canv.ctx.shadowOffsetX = 0;
            canv.ctx.shadowOffsetY = canv.actionManager.getConstant(this.height / 125) * canv.m[3];
        }
        canv.ctx.fillStyle = this.color;
        canv.ctx.fillRect(this.startX, this.startY, this.width, this.height);
        canv.ctx.restore();

        this.textPart.draw();
    }

    translate(x, y) {
        this.startX += x;
        this.startY += y;
        this.updateDims(true);
    }

    clearText() {
        this.textPart.clearText();
        this.updateDims();
    }

    searchText(text) {
        const stickerText = this.textPart.getText().toLowerCase();

        if (stickerText.includes(text)) {
            return [{
                "status": true,
                "textWidget": this.textPart,
                "mode": 'widget',
            }]
        }

        return [];
    }


    // Обработчики для меню

    menuColor(color) {
        this.color = color;
        this.textPart.menuTextColor(getContrastColor(color), true);
        // update last used color in stickerTool
        var stickerColor = canv.toolBox.TryGetToolByName("stickerTool");
        stickerColor.setColor(this.color);
    }

    menuTextBold(value) {
        this.textPart.menuTextBold(value);
        this.updateDims();
    }

    menuTextStrike(value) {
        this.textPart.menuTextStrike(value);
        this.updateDims();
    }

    menuTextBulleted(value) {
        this.textPart.menuTextBulleted(value);
        this.updateDims();
    }

    menuTextAlign(value) {
        this.textPart.menuTextAlign(value);
        this.updateDims();
    }

    menuLink(currentLink) {
        if (this.textPart.isFocused) {
            this.textPart.menuLink(currentLink, this.updateDims.bind(this));
        } else {
            canv.toolBox.TryGetToolByName("cursorTool").setSelectedAndInteraction(this.parent);
            this.textPart.selection.selectAll();
            this.textPart.menuLink(currentLink, this.updateDims.bind(this));
        }
    }


    getWidgetOptions() {
        var widgetOptions = [];
        widgetOptions.push(new widgetOption("stickerColor", this.color, this.UID));

        widgetOptions.push(new widgetOption("textBold", this.textPart.fontBold, this.UID));
        widgetOptions.push(new widgetOption("textStrike", this.textPart.fontStrike, this.UID));
        widgetOptions.push(new widgetOption("textBulleted", this.textPart.bullettedList, this.UID));
        widgetOptions.push(new widgetOption("textAlign", this.textPart.align, this.UID));

        this.textPart.setAffectedItemsUniqValues(widgetOptions, "link", "link", this.UID);
        this.textPart.setEditTextMobile(widgetOptions, this.UID);

        return widgetOptions;
    }

    getHandlerForOption(name) {
        if (name === "stickerColor") {
            return this.menuColor;
        } else if (name === "textBold") {
            return this.menuTextBold;
        } else if (name === "textStrike") {
            return this.menuTextStrike;
        } else if (name === "textBulleted") {
            return this.menuTextBulleted;
        } else if (name === "link") {
            return this.menuLink;
        } else if (name === 'mobileEdit') {
            return this.textPart.menuMobileEdit;
        } else if (name === "textAlign") {
            return this.menuTextAlign;
        }
    }

    // Далее для statesManager

    getFixType(reason) {
        var fixType = "full";

        switch (reason) {

            case "move":
                fixType = "move";
                break;
            case "resize":
                fixType = "resize";
                break;
            case "wm_stickerColor":
                fixType = "color";
                break;
            case "wm_textBold":
            case "wm_textStrike":
            case "wm_textBulleted":
                fixType = "full";
                break;

        }

        return fixType;
    }

    getState(fixType) {
        var state = {};

        switch (fixType) {

            case "move":
                state["startX"] = this.startX;
                state["startY"] = this.startY;
                break;
            case "resize":
                state["startX"] = this.startX;
                state["startY"] = this.startY;
                state["width"] = this.width;
                state["height"] = this.height;
                break;
            case "color":
                state["color"] = this.color;
                break;
            case "bold":
                state.textPart = this.textPart.getState('full');
                break;
            case "full":
                state["UID"] = this.UID;
                state["parentUID"] = this.parentUID;
                state["entityType"] = "stickerWidget";
                state["color"] = this.color;
                state["height"] = this.height;
                state["width"] = this.width;
                state["padding"] = this.padding;
                state["startX"] = this.startX;
                state["startY"] = this.startY;

                state["textPart"] = this.textPart.getState("full");
                break;

        }


        return state;
    }

    loadState(stateObj, fixType) {
        switch (fixType) {

            case "move":
                this.startX = getNumberProperty("startX", stateObj);
                this.startY = getNumberProperty("startY", stateObj);
                break;
            case "resize":
                this.startX = getNumberProperty("startX", stateObj);
                this.startY = getNumberProperty("startY", stateObj);
                this.width = getNumberProperty("width", stateObj);
                this.height = getNumberProperty("height", stateObj);
                break;
            case "color":
                this.color = getColorProperty("color", stateObj);
                this.textPart.menuTextColor(getContrastColor(this.color), true)
                break;
            case "bold":
                this.textPart.loadState(stateObj["textPart"], "full");
                break;
            case "full":
                this.UID = getStringProperty("UID", stateObj);
                this.parentUID = getStringProperty("parentUID", stateObj);
                this.color = getColorProperty("color", stateObj);
                this.width = getNumberProperty("width", stateObj);
                this.height = getNumberProperty("height", stateObj);
                this.padding = getNumberProperty("padding", stateObj);
                this.startX = getNumberProperty("startX", stateObj);
                this.startY = getNumberProperty("startY", stateObj);
                this.textPart.loadState(stateObj["textPart"], "full");

                this.textPart.menuTextColor(getContrastColor(this.color), true);
                break;
        }

        this.updateDims();
    }



    constructorName = "sticker";
    startX = 0;
    startY = 0;
    width = 0;
    height = 0;

    /**
     * @type {textWidget}
     */
    textPart = null;
    padding = 25; //20;

    /**
     * @type {string}
     */
    color = null;
}

